import type { components } from "#open-fetch-schemas/atlit";

export function formatTelestration(telestration: components["schemas"]["TelestrationPlay"]) {
  return {
    id: telestration.id,
    targetId: telestration.attributes.targetId,
    eventId: telestration.attributes.eventId,
    owner: telestration.attributes.owner,
    start: telestration.attributes.start,
    body: telestration.attributes.body,
  };
}
